// entrypoint actions
export const INITIALIZE_LOGIN = 'INITIALIZE_LOGIN';
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const SET_SELECTED_TENANT = 'SET_SELECTED_TENANT';
export const SET_SELECTED_BUSINESSCONTEXT = 'SET_SELECTED_BUSINESSCONTEXT';
export const SET_ROWS_PER_PAGE = 'SET_ROWS_PER_PAGE';
export const LOGIN_READY = 'LOGIN_READY';
export const ENSURE_AUTH = 'ENSURE_AUTH';

export const CHECK_ADSAML = 'CHECK_ADSAML';
export const CHECKING_ADSAML_SUCCEEDED = 'CHECKING_ADSAML_SUCCEEDED';
export const CHECKING_ADSAML_FAILED = 'CHECKING_ADSAML_FAILED';

export const UPDATE_ADSAML_DETAILS = 'UPDATE_ADSAML_DETAILS';
export const SSO_LOG_IN = 'SSO_LOG_IN';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_FAILED = 'RESET_PASSWORD_FAILED';
export const REFRESH_PASSWORD_EXPIRATION = 'REFRESH_PASSWORD_EXPIRATION';

export const FORGOT_PASSWORD = 'FORGOT_PASSWORD';
export const FORGOT_PASSWORD_SUCCEEDED = 'FORGOT_PASSWORD_SUCCEEDED';
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';

export const FORGOT_USERNAME = 'FORGOT_USERNAME';
export const FORGOT_USERNAME_SUCCEEDED = 'FORGOT_USERNAME_SUCCEEDED';
export const FORGOT_USERNAME_FAILED = 'FORGOT_USERNAME_FAILED';

export const GET_SECURITY_QUESTION = 'GET_SECURITY_QUESTION';
export const GET_SECURITY_QUESTION_SUCCEEDED =
  'GET_SECURITY_QUESTION_SUCCEEDED';
export const GET_SECURITY_QUESTION_FAILED = 'GET_SECURITY_QUESTION_FAILED';

export const SEND_FORGOT_PASSWORD = 'SEND_FORGOT_PASSWORD';
export const SEND_FORGOT_PASSWORD_SUCCEEDED = 'SEND_FORGOT_PASSWORD_SUCCEEDED';
export const SEND_FORGOT_PASSWORD_FAILED = 'SEND_FORGOT_PASSWORD_FAILED';

export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const REFRESH_TOKEN_SUCCEEDED = 'REFRESH_TOKEN_SUCCEEDED';
export const REFRESH_TOKEN_FAILED = 'REFRESH_TOKEN_FAILED';
export const REFRESH_SESSION_TOKEN = 'REFRESH_SESSION_TOKEN';

export const SESSION_START = 'SESSION_START';
export const SESSION_ENDING = 'SESSION_ENDING';
export const SESSION_ENDED = 'SESSION_ENDED';

// async actions
export const LOGGING_IN = 'LOGGING_IN';
export const LOGGING_IN_SUCCEEDED = 'LOGGING_IN_SUCCEEDED';
export const LOGGING_IN_FAILED = 'LOGGING_IN_FAILED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';

export const LOGGING_OUT = 'LOGGING_OUT';
export const LOGGING_OUT_SUCCEEDED = 'LOGGING_OUT_SUCCEEDED';
export const LOGGING_OUT_FAILED = 'LOGGING_OUT_FAILED';

export const GET_LICENSES = 'GET_LICENSES';
export const GETTING_LICENSES_SUCCEEDED = 'GETTING_LICENSES_SUCCEEDED';
export const GETTING_LICENSES_FAILED = 'GETTING_LICENSES_FAILED';

export const GET_LOGO_DETAILS = 'GET_LOGO_DETAILS';
export const GETTING_LOGO_DETAILS_SUCCEEDED = 'GETTING_LOGO_DETAILS_SUCCEEDED';
export const GETTING_LOGO_DETAILS_FAILED = 'GETTING_LOGO_DETAILS_FAILED';

//two-factor authentication
export const GET_AUTHENTICATION = 'GET_AUTHENTICATION';
export const PROCEED_AUTHENTICATION = 'PROCEED_AUTHENTICATION';
export const PROCEED_AUTHENTICATION_FAILED = 'PROCEED_AUTHENTICATION_FAILED';
export const SEND_CODE_THROUGH_SMS = 'SEND_CODE_THROUGH_SMS';
export const SEND_CODE_THROUGH_EMAIL = 'SEND_CODE_THROUGH_EMAIL';
export const UPDATE_SEND_CODE_STATUS = 'UPDATE_SEND_CODE_STATUS';

export const GET_SUPPORT_USER_DETAILS = 'GET_SUPPORT_USER_DETAILS';
export const GETTING_SUPPORT_USERS_SUCCEEDED =
  'GETTING_SUPPORT_USERS_SUCCEEDED';
export const GETTING_SUPPORT_USERS_FAILED = 'GETTING_SUPPORT_USERS_FAILED';
export const SUPPORT_USER_SELECTED = 'SUPPORT_USER_SELECTED';
export const LOGIN_AS_SUPPORT_USER = 'LOGIN_AS_SUPPORT_USER';
export const SUPPORT_USER_LOGIN_SUCCEEDED = 'SUPPORT_USER_LOGIN_SUCCEEDED';
export const RESET_ADMIN_MESSAGE = 'RESET_ADMIN_MESSAGE';
export const SET_CONTEXT_DETAILS = 'SET_CONTEXT_DETAILS';
export const GETTING_LOGIN_DETAILS_SUCCEEDED =
  'GETTING_LOGIN_DETAILS_SUCCEEDED';

export const GET_TENANT_LIST = 'GET_TENANT_LIST';
export const GETTING_TENANT_LIST_SUCCEEDED = 'GETTING_TENANT_LIST_SUCCEEDED';
export const GETTING_TENANT_LIST_FAILED = 'GETTING_TENANT_LIST_FAILED';

export const GETTING_TENANT_DETAILS_SUCCEEDED = 'GETTING_TENANT_DETAILS_SUCCEEDED';

export const initializeLogin = () => ({
  type: INITIALIZE_LOGIN
});

export const login = (username, password, options) => ({
  type: LOG_IN,
  username,
  password,
  options
});
export const getAuthentication = loginData => ({
  type: GET_AUTHENTICATION,
  loginData
});
export const proceedAuthentication = code => ({
  type: PROCEED_AUTHENTICATION,
  code
});
export const proceedAuthenticationFailed = error => ({
  type: PROCEED_AUTHENTICATION_FAILED,
  error
});
export const sendCodeThroughSms = username => ({
  type: SEND_CODE_THROUGH_SMS,
  username
});
export const sendCodeThroughEmail = username => ({
  type: SEND_CODE_THROUGH_EMAIL,
  username
});
export const updateSendCodeStatus = (sendCodeStatus, sendCodeMode) => ({
  type: UPDATE_SEND_CODE_STATUS,
  sendCodeStatus,
  sendCodeMode
});
export const logout = options => ({
  type: LOG_OUT,
  options
});
export const setSelectedTenant = (tenantId, clearStore) => ({
  type: SET_SELECTED_TENANT,
  tenantId,
  clearStore
});
export const setSelectedBusinessContext = (businessContextId, clearStore) => ({
  type: SET_SELECTED_BUSINESSCONTEXT,
  businessContextId,
  clearStore
});
export const setRowsPerPage = rowsPerPage => ({
  type: SET_ROWS_PER_PAGE,
  rowsPerPage
});
export const loginReady = () => ({
  type: LOGIN_READY
});
export const ensureAuth = () => ({
  type: ENSURE_AUTH
});

export const loggingIn = () => ({
  type: LOGGING_IN
});
export const loggingInSucceeded = user => ({
  type: LOGGING_IN_SUCCEEDED,
  user
});
export const loginSuccess = data => ({
  type: LOGIN_SUCCESS,
  data
});

export const loggingInFailed = error => ({
  type: LOGGING_IN_FAILED,
  error
});

export const loggingOut = () => ({
  type: LOGGING_OUT
});

export const loggingOutSucceeded = options => ({
  type: LOGGING_OUT_SUCCEEDED,
  options
});
export const loggingOutFailed = error => ({
  type: LOGGING_OUT_FAILED,
  error
});

export const ssoLogIn = adsamlDetails => ({
  type: SSO_LOG_IN,
  adsamlDetails
});
export const checkAdsaml = tenantId => ({
  type: CHECK_ADSAML,
  tenantId
});
export const checkingAdsamlSucceeded = isAdsamlEnabled => ({
  type: CHECKING_ADSAML_SUCCEEDED,
  isAdsamlEnabled
});
export const checkingAdsamlFailed = msg => ({
  type: CHECKING_ADSAML_FAILED,
  msg
});
export const updateAdsamlDetails = adsamlDetails => ({
  type: UPDATE_ADSAML_DETAILS,
  adsamlDetails
});

export const resetPassword = updatedPassword => ({
  type: RESET_PASSWORD,
  updatedPassword
});

export const resetPasswordFailed = error => ({
  type: RESET_PASSWORD_FAILED,
  error
});

export const refreshPasswordExpiration = () => ({
  type: REFRESH_PASSWORD_EXPIRATION
});

export const forgotPassword = username => ({
  type: FORGOT_PASSWORD,
  username
});

export const forgotPasswordSucceeded = data => ({
  type: FORGOT_PASSWORD_SUCCEEDED,
  data
});

export const forgotPasswordFailed = error => ({
  type: FORGOT_PASSWORD_FAILED,
  error
});

export const forgotUsername = data => ({
  type: FORGOT_USERNAME,
  data
});

export const forgotUsernameSucceeded = contactType => ({
  type: FORGOT_USERNAME_SUCCEEDED,
  contactType
});

export const forgotUsernameFailed = error => ({
  type: FORGOT_USERNAME_FAILED,
  error
});

export const getSecurityQuestion = () => ({
  type: GET_SECURITY_QUESTION
});

export const getSecurityQuestionSucceeded = question => ({
  type: GET_SECURITY_QUESTION_SUCCEEDED,
  question
});

export const getSecurityQuestionFailed = error => ({
  type: GET_SECURITY_QUESTION_FAILED,
  error
});


export const sendForgotPassword = option => ({
  type: SEND_FORGOT_PASSWORD,
  option
});

export const sendForgotPasswordSucceeded = data => ({
  type: SEND_FORGOT_PASSWORD_SUCCEEDED,
  data
});

export const sendForgotPasswordFailed = error => ({
  type: SEND_FORGOT_PASSWORD_FAILED,
  error
});

export const refreshToken = () => ({
  type: REFRESH_TOKEN
});

export const refreshTokenSucceeded = () => ({
  type: REFRESH_TOKEN_SUCCEEDED
});

export const refreshTokenFailed = () => ({
  type: REFRESH_TOKEN_FAILED
});

export const refreshSessionToken = () => ({
  type: REFRESH_SESSION_TOKEN
});

export const sessionStart = () => ({
  type: SESSION_START
});

export const sessionEnding = () => ({
  type: SESSION_ENDING
});

export const sessionEnded = () => ({
  type: SESSION_ENDED
});

export const getLicenses = data => ({
  type: GET_LICENSES,
  data
});

export const gettingLicensesSucceeded = data => ({
  type: GETTING_LICENSES_SUCCEEDED,
  data
});

export const gettingLicensesFailed = error => ({
  type: GETTING_LICENSES_FAILED,
  error
});

export const getLogoDetails = () => ({
  type: GET_LOGO_DETAILS
});

export const gettingLogoDetailsSucceeded = data => ({
  type: GETTING_LOGO_DETAILS_SUCCEEDED,
  data
});

export const gettingLogoDetailsFailed = error => ({
  type: GETTING_LOGO_DETAILS_FAILED,
  error
});

export const getSupportUserDetails = data => ({
  type: GET_SUPPORT_USER_DETAILS,
  data
});

export const gettingSupportUsersSucceeded = data => ({
  type: GETTING_SUPPORT_USERS_SUCCEEDED,
  data
});

export const gettingSupportUsersFailed = error => ({
  type: GETTING_SUPPORT_USERS_FAILED,
  error
});

export const supportUserSelected = data => ({
  type: SUPPORT_USER_SELECTED,
  data
});
export const loginAsSupportUser = data => ({
  type: LOGIN_AS_SUPPORT_USER,
  data
});
export const supportUserLoginSucceeded = user => ({
  type: SUPPORT_USER_LOGIN_SUCCEEDED,
  user
});
export const resetAdminMessage = () => ({
  type: RESET_ADMIN_MESSAGE
});
export const setContextDetails = details => ({
  type: SET_CONTEXT_DETAILS,
  details
});
export const gettingLoginDetailsSucceeded = details => ({
  type: GETTING_LOGIN_DETAILS_SUCCEEDED,
  details
});
export const getTenantList = data => ({
  type: GET_TENANT_LIST,
  data
});
export const gettingTenantListSucceeded = details => ({
  type: GETTING_TENANT_LIST_SUCCEEDED,
  details
});
export const gettingTenantListFailed = data => ({
  type: GETTING_TENANT_LIST_FAILED
});

export const gettingTenantDetailsSucceeded = data => ({
  type: GETTING_TENANT_DETAILS_SUCCEEDED,
  data
})
